import React,{useState,useEffect,useRef} from 'react';
import { Route, Link, NavLink ,Switch, useHistory } from 'react-router-dom';
import Content from './Content';
import imgA from './img/abys_logo_top.png';
import imgB from './img/abys_logo_bg.png';
import imgprofile from './img/Ellipse 1.png';
import Login from './Login';
import Logout from './Logout';
import Content_m from './Content_m';
import Register from './Register';
import Complete from './Complete';
import ServiceApply from './Pc_ServiceApply';
import Pc_ServiceInfo from './Pc_ServiceInfo';
import Certification from './Certification';
import CarManagement from './CarManagement';
import Pc_Storeinformation from './Pc_Storeinformation';
import Pc_FindShop from './Pc_FindShop';
import Shop from './Pc_Shop';
import ShopDetail from './Pc_ShopDetail';
import Pc_Progress_Real from './Pc_Progress_Real';
import DriverInform from './DriverInform';
import CarmasterInform from './CarmasterInform';
import CapitalCalendar from './Pc_CapitalCalendar';
import ReservationInfo from './ReservationInfo';
import ReservationComplete from './ReservationComplete';

import MyService from './MyService';
import Pc_Mypagemain from './Pc_Mypagemain';
import Pc_ServiceAll from './Pc_ServiceAll';
import {instance} from './common';
import Represent from './Represent';
import RepInsert from './RepInsert';
import RepCheck from './RepCheck';
import Pc_RepFindShop from './Pc_RepFindShop';
import RepStoreInfo from './RepStoreInfo';
import Mypageedit from './Mypageedit';
import Pc_RepReserve from './Pc_RepReserve';
import Pc_Cart from './New_Cart';
import RepCalendar from './Pc_RepCalendar';
import InsertCar from './InsertCar';
import Pc_MyReserve from './Pc_MyReserve';
import NoticeList from './Pc_NoticeList';
import FaqList from './Pc_FaqList';
import NoticeDetail from './Pc_NoticeDetail';
import Pc_Reserve_detail from './Pc_Reserve_detail';
import RepReserve_detail from './RepReserve_detail';
import sigong_list from './Sigong_list';
import { Cookies } from 'react-cookie';
// import Footer from './Footer';
import Test from './Test';
import calendarchoice from './CalendarChoice';
import Si_reserve_detail from './Si_reserve_detail';
import S_storeSetting from './S_storeSetting';
import CustomerInfo from './CustomerInfo';
import WorkDetailPage from './WorkDetailPage';
import Month_list from './Month_list';
import Holiday from './Holiday';
import StoreManage from './StoreManage';
import StoreSetting from './StoreSetting';
import Customer_manage from './Customer_manage';
import Progress_list from './Progress_list';
import Allim from './Allim';
import kakao_png from './img/kakao_icon.png';
import Product from './Product';
import P_cart from './P_cart';
import Product_detail from './Product_detail';
import OrderSheet from './OrderSheet';
import OrderDetail from './OrderDetail';
import ProductManage from './ProductManage';
import OrderPage from './OrderPage';
import Maechul from './Maechul';
import MaechulList from './MaechulList';
import Jungsan from './Jungsan';
import Quality from './Quality';
import BojungOk from './BojungOk';
import ModalPage from './ModalPage';
import EventNotice from './Pc_EventNotice';
import EventDetail from './Pc_EventDetail';
import ScrollToTop from './util/ScrollToTop';
import Pc_s_FindShop from './Pc_s_FindShop';
import Ksolution from './Ksolution';
import Klist from './Klist';
import Sungard from './Sungard';
import SunList from './SunList';
import Casper from './Casper';
import Ray from './Ray';

import imgFrameBang1 from './img/main_img_1.jpg';
import imgFrameBang2 from './img/main_img_2.jpg';
import imgFrameBang3 from './img/main_img_3.png';

import service1 from './img/service1.jpg';
import service2 from './img/service2.jpg';
import service3 from './img/service3.jpg';
import service4 from './img/service4.jpg';



import casper_bg from './img/casper_bg.png';
import ray_bg from './img/ray_bg.png';



function Header(){

    const [isShown, setIsBtn] = useState(false);

    const history = useHistory();

    const headerText = {
        cursor:"pointer",
        fontWeight: 'bold',
        fontSize: '17px',
        marginRight:'20px'
    }

    const [modal, setModal] = useState(false);
    const toggle = (e) => {
        const { name } = e.target.dataset;
        setModal(!modal);
        
    }

    let u_uuid = '';
    if(window.sessionStorage.result){
        let parseSe = JSON.parse(window.sessionStorage.result);
        // u_type = parseSe.u_type;
        u_uuid = parseSe.u_uuid;
        
    }
    const [bannerType, setBannerType] = useState('main');
    const [bgUrl , setbgUrl] = useState([
        {
            type:'main',
            src:`url('${imgFrameBang1}')`
        },
        {
            type:'d2c',
            src:`url('${imgFrameBang2}')`
        },
        {
            type:'k',
            src:`url('${imgFrameBang2}')`
        },
        {
            type:'sun',
            src:`url('${imgFrameBang3}')`
        },
        {
            type:'casper',
            src:`url('${casper_bg}')`
        },
        {
            type:'ray',
            src:`url('${ray_bg}')`
        },
        {
            type:'btob',
            src:`url('${imgFrameBang2}')`
        },
    ])

    const goCateNext = (typed) => {
        console.log('typed : ', typed)
       
        if(typed === 'd2c'){
            alert('죄송합니다.\n현대캐피탈 고객 전용 페이지 입니다.');
        }else if(typed === 'k'){
            setBannerType(typed)
            history.push('/ksolution')
            //window.location.replace('/ksolution')
        }else if(typed === 'sun'){
            setBannerType(typed)
            history.push('/sungard')
        }else{
            alert('준비중입니다.');
        }
    }
    
 
    return (
        <>
            <header className="container-fluid position-absolute p-5 clearfix">
                <div className="float-left">
                    {
                        bannerType
                        ? <Link to="/" onClick={() => setBannerType('main')}><img src={imgA} className="h_logo_wrap" style={{width:'95px'}}/></Link>
                        : <Link to="/" onClick={() => setBannerType('main')}><img src={imgB} className="h_logo_wrap" style={{width:'95px'}}/></Link>

                    }       
                </div>
                <div className="float-right">
                    {
                        bannerType
                        ? <ul>
                                {
                                    window.sessionStorage.result
                                    ? 
                                    <>
                                    <li onClick={ ()=> {window.location.href="/mypagemain"} } style={headerText}>마이페이지</li>
                                    <li onClick={ ()=> {window.location.href="/logout"} } style={headerText}>로그아웃</li>
                                </>
                                
                                    : 
                                    <>
                                    <li onClick={toggle} style={{...headerText,color:'#fff'}}>회원가입</li>
                                    <li id="login-text" onClick={toggle} style={{...headerText,color:'#fff'}}>로그인</li>
                                    </>
                                }
                                
                                <li className="search_btn" onClick={() => {history.push('/shop')}}  onMouseEnter={() => setIsBtn(true)} onMouseLeave={() => setIsBtn(false)} style={headerText}>시공점 검색</li>

                            </ul>
                        : <ul>
                                {
                                    window.sessionStorage.result
                                    ? 
                                        u_uuid
                                        ?<Link to="/mypagemain"><img className="myprofile" src={u_uuid}/></Link>
                                        :
                                        <>
                                            <li onClick={ ()=> {window.location.href="/mypagemain"} } style={headerText}>마이페이지</li>
                                            <li onClick={ ()=> {window.location.href="/logout"} } style={headerText}>로그아웃</li>
                                        </>
                                
                                    : 
                                    <>
                                    <li onClick={toggle} style={{...headerText,color:'#000'}}>회원가입</li>
                                    <li id="login-text" onClick={toggle} style={{...headerText,color:'#000'}}>로그인</li>
                                    </>
                                }
                                
                                <li className="search_btn" onClick={() => {history.push('/shop')}}  onMouseEnter={() => setIsBtn(true)} onMouseLeave={() => setIsBtn(false)} style={headerText}>시공점 검색</li>

                            </ul>

                    }   

                </div>
                    
            </header>
            {
                !bannerType &&
                <div style={{height:'97px'}}></div>
            }

            {
                bgUrl.map((v,i) => v.type === bannerType && <div className="main-top-banner" key={i} style={{backgroundImage:v.src}}></div>)
            }
           
            {
                bannerType === 'main' &&
                <div className="container clearfix position-relative" style={{top:'-40px'}}>
                    {/* 이거 링크달린거 */}
                    {/* <div className="float-left" style={{marginRight:'1.33%',width:'24%',boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><img className="pointer w-100" src={service1} onClick={() => {goCateNext('d2c')}}/></div>
                    <div className="float-left" style={{marginRight:'1.33%',width:'24%',boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><img className="pointer w-100" src={service2}  onClick={() => {goCateNext('k')}}/></div>
                    <div className="float-left" style={{marginRight:'1.33%',width:'24%',boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><img className="pointer w-100" src={service3}  onClick={() => {goCateNext('sun')}}/></div>
                    <div className="float-left" style={{width:'24%',boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><img className="pointer w-100" src={service4}  onClick={() => {goCateNext('btob')}}/></div> */}
                    <div className="float-left" style={{marginRight:'1.33%',width:'24%',boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><img className="pointer w-100" src={service1}/></div>
                    <div className="float-left" style={{marginRight:'1.33%',width:'24%',boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><img className="pointer w-100" src={service2}  /></div>
                    <div className="float-left" style={{marginRight:'1.33%',width:'24%',boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><img className="pointer w-100" src={service3} /></div>
                    <div className="float-left" style={{width:'24%',boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><img className="pointer w-100" src={service4}  /></div>
                </div>
            }

            <ScrollToTop />
            <Switch>
                <Route exact path="/" component={Content} />
                <Route 
                    path="/ksolution"
                    render={() => <Ksolution setBannerType={setBannerType}/>}
                />
                <Route 
                    path="/klist"
                    render={() => <Klist setBannerType={setBannerType} />}
                />
                <Route 
                    path="/sungard"
                    render={() => <Sungard setBannerType={setBannerType}/>}
                />
                <Route 
                    path="/sunlist"
                    render={() => <SunList setBannerType={setBannerType}/>}
                />
                <Route 
                    path="/casper"
                    render={() => <Casper setBannerType={setBannerType}/>}
                />
                <Route 
                    path="/ray"
                    render={() => <Ray setBannerType={setBannerType}/>}
                />
                <Route path="/Logout" component={Logout} />
                <Route path="/join" component={Register} />
                <Route path="/login" component={Login}/>
                <Route path="/complete" component={Complete} />
                <Route path="/apply" component={ServiceApply} />
                <Route path="/service" component={Pc_ServiceInfo}/>
                <Route path="/serviceAll" component={Pc_ServiceAll} />
                <Route path="/certify" component={Certification} />
                <Route path="/management" component={CarManagement} />
                <Route path="/storeinfo" component={Pc_Storeinformation} />
                <Route path="/shop/:id" component={ShopDetail} />
                <Route path="/mypagemain" component={Pc_Mypagemain} />
                <Route path="/findshop" component={Pc_FindShop} />
                <Route path="/s_findshop" component={Pc_s_FindShop} />
                <Route path="/shop" component={Shop} />
                <Route path="/progress" component={Pc_Progress_Real} />
                <Route path="/driverinform" component={DriverInform} />
                <Route path="/carmaster" component={CarmasterInform} />
                <Route path="/capitalcalendar" component={CapitalCalendar} />
                <Route path="/reservationinfo" component={ReservationInfo} />
                <Route path="/resercomplete" component={ReservationComplete} />
                <Route path="/myservice" component={MyService} />
                <Route path="/represent" component={Represent} />
                <Route path="/repInsert" component={RepInsert} />
                <Route path="/repCheck" component={RepCheck} />
                <Route path="/repFindShop" component={Pc_RepFindShop} />
                <Route path="/repStoreInfo" component={RepStoreInfo} />
                <Route path="/mypageedit" component={Mypageedit} />
                <Route path="/repReserve" component={Pc_RepReserve} />
                <Route 
                    path="/cart"
                    render={() => <Pc_Cart setBannerType={setBannerType} />}
                />
                <Route path="/repCalendar" component={RepCalendar} />
                <Route path="/insertCar" component={InsertCar} />
                <Route path="/myReserve" component={Pc_MyReserve} />
                <Route path="/noticelist" component={NoticeList} />
                <Route path="/faqlist" component={FaqList} />
                <Route path="/reserve_detail" component={Pc_Reserve_detail} />
                <Route path="/repReserve_detail" component={RepReserve_detail} />
                <Route path="/noticedetail" component={NoticeDetail} />
                <Route path="/test" component={Test} />
                <Route path="/calendarchoice" component={calendarchoice} />
                <Route path="/si_reserve_detail" component={Si_reserve_detail} />
                <Route path="/s_storesetting" component={S_storeSetting} />
                <Route path="/setting" component={StoreSetting} />
                <Route path="/customerinfo" component={CustomerInfo} />
                <Route path="/workdetailpage" component={WorkDetailPage} />
                <Route path="/month_list" component={Month_list} />
                <Route path="/holiday" component={Holiday} />
                <Route path="/storeManage" component={StoreManage} />
                <Route path="/customer_manage" component={Customer_manage} />
                <Route path="/progress_list" component={Progress_list} />
                <Route path="/allim" component={Allim} />
                <Route path="/product" component={Product} />
                <Route path="/product-detail" component={Product_detail} />
                <Route path="/product-cart" component={P_cart} />
                <Route path="/order-sheet" component={OrderSheet} />
                <Route path="/order-detail" component={OrderDetail} />
                <Route path="/order-page" component={OrderPage} />
                <Route path="/product-manage" component={ProductManage} />
                <Route path="/maechul" component={Maechul} />
                <Route path="/jungsan" component={Jungsan} />
                <Route path="/maechul-list" component={MaechulList} />
                <Route path="/quality-list" component={Quality} />
                <Route path="/bojungok" component={BojungOk} />
                <Route path='/event' component={EventNotice} />
                <Route path="/eventdetail" component={EventDetail} />
            </Switch>            
            <ModalPage toggle={toggle} modal={modal} Comp={Login}/>
        </>
    )

}


export default Header;